import FlyingCoinsAnimation from './FlyingCoinsAnimation';
import { connect } from 'shared/node_modules/react-redux';
import { currencyDisplayComponentName } from '../../CurrencyDisplay/CurrencyDisplay';
import { chestComponentName } from '../../BottomBar/BottomBar';

const mapStateToProps = state => {
  return {
    currencyDisplayXPosition: state.animations[currencyDisplayComponentName]?.x,
    currencyDisplayYPosition: state.animations[currencyDisplayComponentName]?.y,
    currencyDisplayWidth: state.animations[currencyDisplayComponentName]?.width,
    currencyDisplayHeight: state.animations[currencyDisplayComponentName]?.height,
    chestXPosition: state.animations[chestComponentName]?.x,
    chestWidth: state.animations[chestComponentName]?.width,
    chestHeight: state.animations[chestComponentName]?.height,
  };
};

export default connect(mapStateToProps, null)(FlyingCoinsAnimation);
